<template>
  <div class="">

    <div class="gridSection parentContainer">
      <b-container>
        <header class="section-header">
          <h2>{{ title }}</h2>
        </header>
        <div class="section-content">
          <p class="description" v-if="info">
            {{ info }}
          </p>

           <!-- loading -->
          <div class="text-center text-danger my-2 loadingBox" v-show="pageIsLoading">
            <b-spinner class="align-middle"></b-spinner>
          </div>
          <div class="row" v-show="!pageIsLoading">
            <!-- items.length == 0 -->
            <div class="col-md-12 col-sm-12 col-xs-12" v-if="items.length == 0">
              <div class="text-center text-danger my-2">
                <h5>{{ langDec.articles_empty }}</h5>
              </div>
            </div>

            <div :style="{ cursor: !seeMoreBtn ? 'pointer' : 'default' }" @click="!seeMoreBtn && goToRoute('article', item.slug)" v-for="item in items" :key="item.slug" :class="'col-md-' + cols" class=" col-sm-6 col-xs-6">
              <div class="transBox">
                <div class="transBox-icon">
                  <img class="gridSection-img" :src="item.imageUrl" :alt="`${langDec.articles_card_alt_prefix} ${item.title}`" />
                </div>
                <div class="transBox-text">
                  <div >
                    <div class="transBox-time" v-if="time">
                      <span>
                        {{ item.publishDateTime }}
                      </span>
                    </div>
                    <h5>
                     {{ item.title }}
                    </h5>
                    <div class="transBox-p" v-if="false">
                      <p>
                        {{ item.descripiton }}
                      </p>
                    </div>
                  </div>
                  <div v-if="seeMoreBtn" class="link"><b-link :href="'/article/' + item.slug">{{ langDec.articles_read_more }}</b-link></div>
                </div>
              </div>
            </div>
          </div>
          <br>
          <!-- Load more button (backwards-compatible: supports both hasLoadMore and loadMore props) -->
          <b-button class="px-4 py-2 my-5" variant="primary" v-if="(hasLoadMore || loadMore) && totalCount > items.length">
            <span @click="loadMore()">{{ langDec.articles_load_more_conditions }}</span>
          </b-button>

          <!-- Numbered pagination -->
          <div v-if="pagination && totalCount > 0" class="my-3">
            <b-pagination
              v-model="pageNumber"
              :per-page="pageSize || 8"
              :total-rows="totalCount"
              align="center"
              size="sm"
              @change="onPageChanged"
            ></b-pagination>
          </div>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
  import { sendRequest } from '../utils/RequestHelper.js'
  import { mapGetters } from 'vuex'
  import expertCarousel from "./ExpertCarousel.vue"
  export default {
    props: ["title", "info", "cols", "seeMoreBtn", "hasLoadMore", "loadMore", "pagination", "descripiton", "time", "pageSize", "hidecurrentId"],
    name: 'Home',
    data() {
      return {
        pageIsLoading: true,
        items: [],
        pageNumber: 1,
        totalCount: 0
      }
    },
    components: {
      expertCarousel
    },
    computed: {
      ...mapGetters(['getLangData']),
      langDec() {
        return this.getLangData || {}
      },
    },
    watch: {
      '$route.query.specializationId': function() {
        this.pageNumber = 1;
        this.loadData(false, this.pageSize);
      }
    },
    methods: {
  
      goToRoute(name, id) {
        this.$router.push({
          name: name,
          params: {
            id: id
          }
        })
      },
      loadMore() {
        this.pageNumber++;
        this.loadData(true, this.pageSize || 8);
      },
      loadData(loadMore, pageSize) {
        this.pageIsLoading = true;
        let body = {
          pageSize: pageSize || this.pageSize || 8,
          pageNumber: this.pageNumber,
          isPublished: true,
          searchTerm: '',
          specializationId: this.$route.query.specializationId
        }
        this.pageIsLoading = true;
        console.log(process.env.VUE_APP_API_URL_IMAGE);
        sendRequest('post', `Blog/search`, true, body,
          (response) => {

if (response?.data?.data?.items?.length) {
  const baseUrl = process.env.VUE_APP_API_URL_IMAGE;

  // Create a new array with updated image URLs
  const updatedItems = response.data.data.items.map(item => ({
    ...item,
    imageUrl: item.imageUrl
      ? `${baseUrl}${item.imageUrl.startsWith('/') ? '' : '/'}${item.imageUrl}`
      : null, // handle if imageUrl is missing or null
  }));

  // Replace items in response if needed
  response.data.data.items = updatedItems;
}

// optional: check results
console.log(response.data.data.items);
            if(loadMore) {
              this.items = this.items.concat(response.data.data.items);
            }
            else{
               this.items = [];
               response.data.data.items.forEach(element => {
                if(element.id != this.hidecurrentId) {
                  this.items.push(element);
                }
               });
            }
            this.totalCount = response.data.data.totalCount;
            this.tableIsLoading = false;
            this.pageIsLoading = false;
          },
          () => {
            this.tableIsLoading = false;
            this.pageIsLoading = false;
            this.alertType = 'danger';
            this.alertText = 'Error loading data';
          }
        );
      }

      ,
      onPageChanged(page) {
        // pageNumber is already updated by v-model; call loadData for new page
        this.pageNumber = page;
        this.loadData(false, this.pageSize);
      }

    },
    created() {
      this.loadData(false, this.pageSize);
    }
  }
</script>

<style scoped>
  
h5, p{
  display: -webkit-box;
  -webkit-line-clamp: 2; 
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: calc(1.5em * 2); /* Ensures at least 2 lines */
  line-height: 1.5em; /* Adjust line height as needed */
  max-width: 100%; /* Optional */

}

  /* parentContainer */
  .parentContainer {
    background-color: white !important;
    text-align: center;
    margin: 30px 0px ;
    
  }
  .transBox-icon img{
    width: 100%;
    height: 250px;
    object-fit: cover;
    margin: 0 auto;
    background-color: #ffffff;
    border-radius: 10px;
    margin-bottom: 10px;
    margin-top: 30px !important;
  }
  .transBox h5{
    font-size: 17px !important;
    font-weight: bold;
    text-align: right;
    margin-top: 15px;
  }
  .transBox .link{
    text-align: right !important; 
    font-size: 14px;
    margin-top: 15px;
    color: #006633;
  }
  .transBox .transBox-p{
    text-align: right;
    color: grey;
    margin-top: 15px;
    font-size: 13px;
  }

  .transBox-time{
    text-align: right;
    font-size: 12px;
    color: #6C757D;
    margin-bottom: -10px;
  }
  @media (max-width: 991.98px) {
    
    .transBox-icon img{
      width: 150px !important;
      height: 150px !important;
      margin-bottom: 10px;
      margin-top: 30px !important;
    }
    
  }

  @media (max-width: 767.98px) {
    
    .transBox h5{
      font-size: 17px !important;
      text-align: center;

    }
    .transBox .link{
      text-align: center !important; 
    }
  }
</style>